module.exports = __webpack_public_path__ + "static/media/Node.js_logo_plain.9ecc31b8.svg";